/**
 * Textos de ajuda para usuários de negócio (sem jargão técnico).
 * Alinhado ao Manual do Portfólio / Dashboard.
 */
export const roboflexHelp = {
  dash_monitorados:
    "Quantos projetos estão sendo acompanhados agora: Não Iniciado, Em Andamento ou Aprovado. Projetos suspensos, concluídos ou cancelados não entram neste número.",
  dash_impacto:
    "Como o projeto é classificado no planejamento (nível do PCM): Estratégico, Tático ou Operacional. Isso indica a importância relativa no portfólio.",
  dash_orcamento:
    "Soma do dinheiro previsto (orçamento) e do dinheiro já comprometido (custo) só dos projetos ativos. O custo inclui o que já foi pago, o que ainda falta pagar e despesas lançadas.",
  dash_atraso:
    "Entre os projetos ativos que já passaram da data de fim e ainda não chegaram a 100% de progresso, mostra a média de dias de atraso.",
  dash_resultados:
    "Entregas dos projetos ativos. Validadas = já aprovadas pela diretoria. Atrasadas = data prevista vencida e ainda não concluídas. O percentual é concluídas ÷ total.",
  dash_entregas:
    "Pacotes de trabalho dos projetos ativos. Em atraso = data prevista já passou e o pacote ainda não foi concluído nem cancelado.",
  dash_matriz:
    "Distribuição dos projetos ativos nos quadrantes Planejamento × Execução. Intervir = plano bem definido, mas execução fraca (prioridade de atenção).",
  dash_alertas:
    "Lista rápida dos casos mais críticos: projetos atrasados, entregas atrasadas, pacotes de trabalho atrasados, tarefas atrasadas e estouro de orçamento.",

  port_resumo:
    "Visão geral de todos os projetos. Clique em um status para filtrar a lista. Suspenso conta como inativo.",
  port_fin_ativos:
    "Soma do orçamento (e do valor consumido) dos projetos Não Iniciado, Em Andamento e Aprovado.",
  port_fin_inativos:
    "Soma do orçamento (e do valor consumido) dos projetos Concluído, Cancelado e Suspenso.",
  port_fin_total:
    "Orçamento e valor consumido de ativos + inativos juntos. No Dashboard o total financeiro considera só os ativos.",
  port_matriz:
    "Quantos projetos ativos caem em cada quadrante da matriz. Clique para filtrar a tabela.",

  col_projeto: "Código, nome do projeto e programa ao qual ele pertence.",
  col_gerente: "Quem é o gerente responsável pelo projeto.",
  col_status: "Situação atual do projeto (não iniciado, em andamento, etc.).",
  col_saude:
    "Saudável, Atenção ou Risco.\n\n• Risco: mais de 30 dias sem atualização, projeto atrasado, ou prazo vencido com pacotes de trabalho incompletos.\n• Atenção: mais de 15 dias sem atualização, ou prazo perto do fim sem pacotes de trabalho concluídos.",
  col_matriz:
    "P (Planejamento) e E (Execução) vão de 0 a 10. São a média das notas dos critérios. O selo (Intervir, Ideal, etc.) diz o que a matriz recomenda fazer.",
  col_entregas: "Quantos pacotes de trabalho já foram concluídos em relação ao total cadastrado.",
  col_tarefas: "Quantas tarefas já foram concluídas em relação ao total (tarefas canceladas não entram no progresso).",
  col_desatualizado:
    "Há quantos dias o projeto não teve movimento recente (projeto, entregas, pacotes de trabalho, tarefas, sprints, reuniões etc.). Logs de gestão não entram. Datas só planejadas no futuro não contam.\n\n• Amarelo: mais de 15 dias\n• Vermelho: mais de 30 dias",
  col_orcamento:
    "Orçamento previsto e, se houver, quanto já foi gasto. Fica em vermelho quando o gasto ultrapassa o orçamento.",
  col_alertas:
    "Sinais rápidos: atraso do projeto (em dias), pacotes de trabalho atrasados (E), tarefas atrasadas (T) e percentual de estouro de custo. O visto verde indica que não há esses alertas.",

  det_saude: "Mesma leitura de Saúde da lista: Saudável, Atenção ou Risco.",
  det_gerente: "Gerente responsável pelo projeto.",
  det_assessor: "Assessor que apoia a gestão do projeto.",
  det_datas: "Data de início e previsão de conclusão usadas no acompanhamento.",
  det_prazo:
    "Compara o tempo decorrido com o prazo previsto. O projeto é considerado atrasado quando a data de fim já passou e o progresso ainda é menor que 100%.",
  det_orcamento:
    "Orçamento previsto versus gasto (pago + a pagar + despesas). Destaca em vermelho se estourou o orçamento ou se há gasto sem orçamento definido.",
  det_matriz:
    "Selo da matriz e as notas P (planejamento) e E (execução), cada uma de 0 a 10. O selo indica a ação sugerida (Intervir, Ideal, etc.).",
  det_matriz_p:
    "Nota de Planejamento (0 a 10): média dos critérios Entregas, Orçamento, Cronograma e Pacotes de trabalho. Faixas: 0–4 baixo, 5–6 médio, 7–10 alto.",
  det_matriz_e:
    "Nota de Execução (0 a 10): média dos critérios Progresso, Custo, Prazo e Atualização. Faixas: 0–4 baixo, 5–6 médio, 7–10 alto.",
  det_matriz_card:
    "Este quadro posiciona o projeto cruzando Planejamento (linhas) com Execução (colunas).\n\n" +
    "No topo aparecem as notas P e E deste projeto (ex.: 8×3). A célula com borda destacada é onde ele está agora, e o selo (Intervir, Agir, Ideal…) resume a recomendação.\n\n" +
    "Como ler as faixas:\n" +
    "• 7–10 = alto\n" +
    "• 5–6 = médio\n" +
    "• 0–4 = baixo\n\n" +
    "O que cada selo sugere:\n" +
    "• Intervir (vermelho): plano bom ou mediano, execução fraca — prioridade na pauta.\n" +
    "• Agir (amarelo): plano alto e execução média — acompanhar de perto.\n" +
    "• Ideal (verde): plano e execução altos — reconhecer o bom desempenho.\n" +
    "• Apoiar (amarelo): plano e execução medianos — reforçar os dois lados.\n" +
    "• Questionar (amarelo): combinação estranha (ex.: execução boa com plano fraco) — investigar.\n" +
    "• Cancelar (cinza): plano e execução baixos — candidato a cancelamento.\n\n" +
    "As notas P e E vêm dos critérios detalhados na seção Critérios, logo abaixo.",
  det_kpi_resultados:
    "Quantidade de entregas do projeto, quantas foram validadas pela diretoria, quantas estão atrasadas e quantas já foram concluídas.",
  det_kpi_entregas:
    "Total de pacotes de trabalho, quantos estão em atraso, quantos concluídos e, se houver, pacotes ainda sem tarefas.",
  det_kpi_tarefas:
    "Total de tarefas, quantas atrasadas e quantas concluídas.",
  det_kpi_desatualizado:
    "Dias desde a última atividade considerada (sem incluir logs de gestão). A referência mostra qual área gerou essa data (por exemplo Entregas ou Pacotes de trabalho). Ao passar o mouse, vê todas as fontes usadas.",
  det_kpi_progresso:
    "Percentual de conclusão com base nas tarefas (concluídas ÷ total válido, sem canceladas).",
  det_kpi_reunioes: "Quantidade de reuniões ligadas a este projeto.",

  det_criterios:
    "Como nascem as notas P e E (cada critério vale de 0 a 10; a média arredondada forma o eixo).\n\n" +
    "PLANEJAMENTO\n" +
    "• Entregas: 3 ou mais validadas = 10; 2 = 7; 1 = 5; nenhuma = 0.\n" +
    "• Orçamento: definido (valor previsto ou todas as entregas com custo / sem_custo) = 10; incompleto = 0.\n" +
    "• Cronograma: início e fim = 10; só um deles = 5; nenhum = 0.\n" +
    "• Pacotes de trabalho: 3 ou mais = 10; 2 = 7; 1 = 5; nenhum = 0.\n\n" +
    "EXECUÇÃO\n" +
    "• Progresso: compara o % real com o esperado pelo calendário. Se o projeto está atrasado, a nota fica no máximo 5.\n" +
    "• Custo: dentro do orçamento = 10; sem orçamento = 5; se estourou, a nota cai conforme o excesso.\n" +
    "• Prazo: quanto dos pacotes de trabalho está no prazo. Projeto atrasado limita a nota a no máximo 5.\n" +
    "• Atualização: até 7 dias = 10; até 15 = 8; até 30 = 5; até 60 = 3; mais de 60 = 0.\n\n" +
    "Se o projeto tem entregas, mas nenhuma foi validada, a nota de Execução fica limitada a no máximo 6.\n" +
    "No score de cada entrega, se ela ainda não foi validada, Planejamento e Execução ficam limitados a no máximo 6.\n\n" +
    "Abaixo de cada linha você vê o motivo da nota deste projeto.",

  det_criterio_resultados:
    "Nota de planejamento pelas entregas validadas pela diretoria: 0 → 0 | 1 → 5 | 2 → 7 | 3 ou mais → 10.",
  det_criterio_orcamento:
    "Nota de planejamento do orçamento: 10 se o orçamento está definido — com valor previsto ou com todas as entregas informando custo ou marcadas como sem custo. 0 se alguma entrega ficou sem custo e sem a marcação de sem custo (falha de preenchimento).",
  det_criterio_cronograma:
    "Nota de planejamento: início e fim preenchidos = 10; só um = 5; nenhum = 0.",
  det_criterio_entregas:
    "Nota de planejamento pela quantidade de pacotes de trabalho: 0 → 0 | 1 → 5 | 2 → 7 | 3 ou mais → 10.",
  det_criterio_progresso:
    "Nota de execução: o progresso real é comparado ao esperado no tempo. Projeto atrasado: nota no máximo 5. Concluído: 10.",
  det_criterio_custo:
    "Nota de execução do custo: dentro do orçamento = 10; sem orçamento = 5; com estouro a nota reduz conforme o percentual ultrapassado.",
  det_criterio_prazos:
    "Nota de execução pelos prazos dos pacotes de trabalho. Quanto mais pacotes atrasados, menor a nota. Projeto atrasado: no máximo 5.",
  det_criterio_atualizacao:
    "Nota de execução pela recência da última atualização: ≤7 dias = 10; ≤15 = 8; ≤30 = 5; ≤60 = 3; >60 = 0.",

  det_impactos:
    "Lista dos problemas que mais afetam a performance deste projeto (desatualização, atraso, custo, falta de plano etc.), para orientar a ação.",

  dash_nota_portfolio:
    "Saúde do portfólio (0 a 100, quanto maior melhor). É a média da criticidade dos projetos em andamento, ponderada pelo impacto estratégico (operacional 1, tático 3, estratégico 5) e invertida: 100 − média. Faixas: ≥70 Ótimo, 50–69 Bom, 30–49 Atenção, <30 Crítico.",
  col_nota_final:
    "Média das notas de planejamento e execução convertida para a escala de 0 a 100. Quanto maior, melhor: a partir de 70 aparece em verde, de 50 a 69 em âmbar e abaixo de 50 em vermelho.",
  det_nota_geral:
    "Média das notas de planejamento e execução da metodologia Roboflex, os mesmos P e E exibidos ao lado, convertida para a escala de 0 a 100. A partir de 70 aparece em verde, de 50 a 69 em âmbar e abaixo de 50 em vermelho.",
};

export function helpText(key) {
  return roboflexHelp[key] || "";
}

/** Mapeia tipo do critério (API) → chave de ajuda */
export function criterioHelpKey(tipo) {
  const map = {
    resultados: "det_criterio_resultados",
    orcamento: "det_criterio_orcamento",
    cronograma: "det_criterio_cronograma",
    entregas: "det_criterio_entregas",
    progresso: "det_criterio_progresso",
    custo: "det_criterio_custo",
    prazos: "det_criterio_prazos",
    atualizacao: "det_criterio_atualizacao",
  };
  return map[tipo] || null;
}
